import {SwiperGamesListMrGreenBox} from "./swiper-games-list.mrgreen.box";

export const SwiperGamesListMrGreenCisBox = SwiperGamesListMrGreenBox;